import placeholder from '../../../assets/img/placeholder.png';
import "./ContactSection.css";
import Location from "../../../assets/img/Location.svg";

const ContactSection = () => {

    const handleImageError = (e) => {
        console.error('Failed to load image:', e.target.src);
        e.target.src = placeholder;
    };

    return (
        <section className="location_section">
            <h2 className="location-title text-center text-md-start mt-2">Location and Contact </h2>
            <div className='loc-Subtitle mb-2 fw-500'>Tap the map to find us on Google Maps!</div>
            <div className="location-content">
                <a href="https://maps.app.goo.gl/RKV1JNRFNxz4n5U39?g_st=com.google.maps.preview.copy" target="_blank" rel="noopener noreferrer" title='Click here to go to restaurant loc on maps'>
                    <img
                        src={Location}
                        alt="Location Map"
                        className="location-map"
                        onError={handleImageError}
                    /></a>


                <div className="address-card">
                    <h3 className="address-title">Address</h3>
                    <p className="address-email"> INFO@MAGICSPICESBITES.CO.UK</p>
                    <p className="address-email"> MAGICSPICESBITES@GMAIL.COM</p>
                    <p className="address-phone">  0116 507 9757</p>
                    <p className="address-phone"> +44 7350 037779</p>
                    <div className="address-social-icons">
                        <a href="https://www.instagram.com/magic_spice_bites/?igsh=MXBzbzdqZXNpM2ZwZw#" target='_blank' rel="noreferrer" aria-label="Instagram" className="details-social-link">
                            <i class="bi bi-instagram"></i>
                        </a>
                        <a href="https://www.facebook.com/share/1URU5tBuKu/?mibextid=wwXIfr" target='_blank' rel="noreferrer" aria-label="Facebook" className="details-social-link">
                            <i class="bi bi-facebook"></i>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;